"use client";

import { GoogleMapContext } from "#/context/GoogleMapContext";
import { useJsApiLoader } from "@react-google-maps/api";
import { type ReactNode } from "react";

export const GoogleMapProvider = ({ children }: { children: ReactNode }) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_KEY || "",
  });

  return (
    <GoogleMapContext.Provider value={{ isLoaded }}>
      {children}
    </GoogleMapContext.Provider>
  );
};
